/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-29 18:05:23
 * @LastEditTime: 2022-01-29 18:45:01
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 惠市宝对账单汇总列表 - 汇总数据订单明细数据
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/HSBList/components/HSBInfoList.jsx
 */

import React, { useState, useRef } from 'react'
import { Button, Modal } from 'antd';
import TableHelper from '../../../../components/TableHelper';
import { fetchPlatformRecordHsbPayOrderSummaryDataOrderList } from '../../../../services/platformAccountingRecord';
import ModalScrollContainer from '../../../../components/ModalScrollContainer';
import { findDict, formatTime } from '../../../../utils';
import HSBInfoDetail from './HSBInfoDetail';
import { mapOrdrTpcd, mapRcnclRsltStcd } from '../../../../axios/dictionaries';




const HSBInfoList = (props) => {
    const [visible, setVisible] = useState(false);
    const [id, setId] = useState(null);
    let HSBInfoDetailRef = useRef()
    const open = (id) => {
        setId(id)
        setVisible(true)
    }
    const close = () => {
        setVisible(false)
    }
    props.getRef && props.getRef({ open });
    const columns = [
        { title: '主订单编号', dataIndex: 'mainOrdrNo', width: 230 },

        { title: '交易日期', dataIndex: 'txnDt', render: (text) => formatTime(text, 'YYYY-MM-DD')},
        { title: '交易时间', dataIndex: 'txnTm', },
        { title: '交易金额', dataIndex: 'txnamt', },
        { title: '手续费', dataIndex: 'hdCg', },
        { title: '支付流水号', dataIndex: 'ordrNo', width: 230 },
        { title: '本行/微信/支付宝', dataIndex: 'lssubnkDsc', },
        { title: '借记卡等', dataIndex: 'pyCrdtpDsc', },

        { title: '订单类型代码', dataIndex: 'ordrTpcd', render: (text) => {
            return findDict(mapOrdrTpcd, text).title
        } },
        { title: '卡号', dataIndex: 'pyrAccno', width: 170 },
        { title: '收款状态代码', dataIndex: 'rcnclRsltStcd', render: (text) => {
            return findDict(mapRcnclRsltStcd, text).title
        } },

        { title: '创建时间', dataIndex: 'createTime',width: 140, render: formatTime},

        
        { title: '操作', dataIndex: 'actions', width: 70, fixed: 'right', render: (text, record) => {
            return <a onClick={() => HSBInfoDetailRef.open(record.id)}>详情</a>
        } }
    ]
    const parseRequestData = (data) => {
        data.summaryDataId = id
        return data
    }
    return (
        <Modal
            visible={visible}
            width={950}
            title="汇总数据订单明细数据"
            destroyOnClose
            footer={<Button onClick={close}>关闭</Button>}
            onCancel={close}
        >
            <ModalScrollContainer>
                {id && (
                    <TableHelper 
                        columns={columns} 
                        scroll={{x: 2000}}
                        parseRequestData={parseRequestData} 
                        request={fetchPlatformRecordHsbPayOrderSummaryDataOrderList}  
                    />
                )}

            </ModalScrollContainer>
            <HSBInfoDetail getRef={ref => HSBInfoDetailRef = ref} />
        </Modal>
    )
}

export default HSBInfoList


// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/HSBList/components/HSBInfoList.jsx